import { actionTypes } from '../actions/neighborhood'

const initial = {
  list: [],
	zones: [],
	detail: '',
  visible: [],
  totalRent: 0,
  totalSale: 0,
  neighborhoodRent: 0,
  neighborhoodSale: 0,
  places: []
}

export default (state = initial, action) => {
  switch (action.type) {

    case actionTypes.RECEIVE_NEIGHBORHOODS:
      return Object.assign({}, state, {
        list: action.neighborhoods
      })

    case actionTypes.START_GET_NEIGHBORHOODS_BY_ZONE:
      return Object.assign({}, state, {
        zones: [],
        loading: true
      })

  	case actionTypes.RECEIVE_NEIGHBORHOODS_BY_ZONE:
      return Object.assign({}, state, {
        zones: action.list,
        loading: false
      })

    case actionTypes.RECEIVE_VISIBLE_NEIGHBORHOODS:
      return Object.assign({}, state, {
        visible: action.list
      })

    case actionTypes.RECEIVE_NEIGHBORHOODS_DETAIL:
      return Object.assign({}, state, {
        detail: action.data
      })

    case actionTypes.RECEIVE_TOTAL_SALE:
      return Object.assign({}, state, {
        totalSale: action.total
      })

    case actionTypes.RECEIVE_TOTAL_RENT:
      return Object.assign({}, state, {
        totalRent: action.total
      })

    case actionTypes.RECEIVE_TOTAL_N_RENT:
      return Object.assign({}, state, {
        neighborhoodRent: action.total
      })

    case actionTypes.RECEIVE_TOTAL_N_SALE:
      return Object.assign({}, state, {
        neighborhoodSale: action.total
      })

    case actionTypes.SET_PLACES:
      return Object.assign({}, state, {
        places: action.places
      })

    case actionTypes.RESET_PLACES:
      return Object.assign({}, state, {
        places: []
      })

    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/neighborhood.js